notDetached